module.exports = __webpack_public_path__ + "media/images/img/company-fe4fb6a81229ff00351c506495e4a0a4.jpg";